import { useEffect, useState } from "react";
import { BasicUserInfoResponseType, FoPaketeResponseType, Wartungsinfo } from "../../../api";
import { mitgliedschaftService } from "../service/MitgliedschaftService";
import IconArrowRight from "../svgs/IconArrowRight";
import IconMitglied from "../svgs/IconMitglied";
import { Hinweis } from "../view/Hinweise";
import { Warnung } from "../view/Warnung";
import { MitgliedschaftPathEnum } from "../enum/MitgliedschaftViewStatsEnums";
import IconHinweis from "../svgs/IconHinweis";
import { URL_BENUTZERKONTO_IDENTITY, URL_NACHRICHTEN, getLink } from "../constants/urls";
import { wartungsinfoService } from "../service/WartungsinfoService";

interface Props {
  userInfo?: BasicUserInfoResponseType;
  kontaktdatenEnabled: boolean;
  loginHandler: () => any;
}

export default function MitgliedschaftHome(props: Props) {
  const [foPakete, setFoPakete] = useState<FoPaketeResponseType>();
  const [wartungsInfoEnabled, setWartungsInfoEnabled] = useState<boolean>();
  const [wartungsInfoTitle, setWartungsInfoTitle] = useState<string>();
  const [wartungsInfoText, setWartungsInfoText] = useState<string>();

  const callLogin = (evt: any) => {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      props.loginHandler();
    }
  };

  useEffect(() => {
    if (props.userInfo && !foPakete) {
      mitgliedschaftService.getFoPakete({}).then((prod) => {
        let data: FoPaketeResponseType = prod.data;
        if (data) {
          setFoPakete(data);
        }
      });
    }
  }, [props.userInfo, foPakete]);

  useEffect(() => {
    wartungsinfoService
      .getWartungsinfo()
      .then((res) => {
        let data: Wartungsinfo = res.data;
        if (data) {
          setWartungsInfoEnabled(data.wartungAktiv);
          setWartungsInfoTitle(data.wartungsTitel);
          setWartungsInfoText(data.wartungsText);
        }
      })
      .catch(() => {
        setWartungsInfoEnabled(false);
      });
  }, []);

  return (
    <>
      <main data-gtm-block="main">
        <section className="members bg--white" data-gtm-section="Mein WKO - eService Blockchain Datenzertifizierung">
          <div className="container col-lg-7">
            <div className="members-header mb-5">
              <div className="headline">
                <div className="headline-bc">
                  <h1>Mitgliedschaft</h1>
                  <h3 className="subtitle">
                    Melden Sie Ihr Gewerbe online ruhend und erstellen Sie eine Bestätigung Ihrer Mitgliedschaft oder
                    jedes anderen beliebigen WKO-Mitgliedsunternehmen.
                  </h3>
                </div>
                <IconMitglied />
              </div>
              {!props.userInfo && (
                <>
                  <button className="btn btn-primary" type="button" onClick={callLogin}>
                    Gleich loslegen
                  </button>
                </>
              )}
              {wartungsInfoEnabled && <Warnung title={wartungsInfoTitle} message={wartungsInfoText || ""}></Warnung>}
            </div>
            <div className="content">
              <>
                {props.userInfo &&
                  foPakete?.foPaketForFoPaketeBySearchCriteria &&
                  foPakete.foPaketForFoPaketeBySearchCriteria.length > 0 && (
                    <div
                      className="related-links bg--peach-secondary-30 mb-5"
                      data-gtm-box="Verwandte Links"
                      data-gtm-element="verwandtelinks"
                    >
                      <h4>Wir freuen uns Sie begrüßen zu dürfen!</h4>
                      <p>Alle wichtigen Informationen zu Ihrer neuen Fachorganisation finden Sie hier:</p>
                      <ul className="row p-0">
                        {foPakete.foPaketForFoPaketeBySearchCriteria?.map((foPaket, index) => {
                          return (
                            <li key={index} className="col-lg-6 ps-3">
                              <IconArrowRight />
                              {(foPaket.link?.startsWith("<a") && (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: foPaket.link || "",
                                  }}
                                ></span>
                              )) || (
                                <>
                                  <a target="_blank" rel="noreferrer" className="btn-link" href={foPaket.link}>
                                    {foPaket.link}
                                  </a>
                                </>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}

                {props.userInfo && !props.userInfo.kammermitgliedschaft && props.userInfo.authenticatedUserMemberId !== "0" && (
                  <>
                    <div
                      className={"alert alert-box alert-danger border-0 rounded-0 bg--peach-secondary mb-5"}
                      role="alert"
                      data-gtm-box="Fehler"
                    >
                      <div className="alert-info-bulb">
                        <IconHinweis />
                        <span>Fehler</span>
                      </div>
                      <div className="alert-danger-content">
                        <p className="title">
                          Mit dieser Anmeldung verfügen Sie über keine Mitgliedschaft zur Wirtschaftskammer!
                        </p>
                        <p>
                          Für die Nutzung des Service „Mitgliedschaft“ benötigen Sie eine Anmeldung mit einem
                          Unternehmen mit aufrechter WKO-Mitgliedschaft.
                          <br />
                          Bitte wählen Sie eine entsprechende Anmeldung aus Ihrer Liste aus.
                        </p>
                      </div>
                    </div>
                  </>
                )}
                {(!props.userInfo || props.userInfo?.kammermitgliedschaft || props.userInfo.authenticatedUserMemberId === "0") && (
                  <>
                    <h4>Ihr Nutzen</h4>
                    <p>
                      Sie benötigen Ihre Gewerbeberechtigung nicht das ganze Jahr, weil Sie zum Beispiel einen
                      Saisonbetrieb führen? Dann ist das Mitgliedschaft eService genau richtig für Sie. Mit diesem
                      Service können Sie als Mitglied Ihre Gewerbeberechtigung mit nur wenigen Klicks online ruhend
                      melden bzw. wieder aufnehmen und noch weitere Services rund um Ihre Mitgliedschaft nutzen.
                    </p>
                    <div className="hinweis">
                      {props.userInfo &&
                        props.userInfo.authenticatedUserMemberId === "0" &&
                        !props.userInfo.stammblattErsteller && (
                          <>
                            <div
                              className={"alert alert-box alert-info border-0 rounded-0 bg--peach-secondary"}
                              role="alert"
                              data-gtm-box="Hinweis"
                            >
                              <div className="alert-info-bulb">
                                <IconHinweis />
                                <span>Hinweis</span>
                              </div>
                              <div className="alert-info-content">
                                <p className="title">Noch kein Unternehmen zugeordnet?</p>
                                <p>
                                  Um alle Services rund um Ihre Mitgliedschaft nutzen zu können,{" "}
                                  <a href={getLink(URL_BENUTZERKONTO_IDENTITY)}>
                                    ordnen Sie jetzt ein Unternehmen Ihrem Benutzerkonto zu.
                                  </a>
                                </p>
                              </div>
                            </div>
                          </>
                        )}
                      {(!props.userInfo || props.userInfo.authenticatedUserMemberId !== "0") && (
                        <>
                          {props.kontaktdatenEnabled && (
                            <Hinweis
                              title="Kontaktdaten"
                              link={MitgliedschaftPathEnum.KONTAKTDATEN}
                              userInfo={props.userInfo}
                              message="Digitale und postalische Zusendeadresse verwalten, sowie einen Überblick über weitere hinterlegte Kontaktinformationen aus Firmen A-Z und Benutzerkonto erhalten."
                            />
                          )}
                          <Hinweis
                            title="Bestätigung"
                            link={MitgliedschaftPathEnum.CREATE_STAMMBLATT}
                            userInfo={props.userInfo}
                            message="Holen Sie sich wichtige Kennzahlen und Informationen zu Ihren aufrechten Mitgliedschaften!"
                          />
                        </>
                      )}
                      {(!props.userInfo ||
                        props.userInfo.authenticatedUserMemberId !== "0" ||
                        props.userInfo.stammblattErsteller) && (
                        <Hinweis
                          title="Firmenauskunft"
                          link={MitgliedschaftPathEnum.STAMMBLATT_SUCHE}
                          userInfo={props.userInfo}
                          message="Informieren Sie sich über andere Unternehmen und beziehen Sie wichtige Details"
                        />
                      )}
                      {(!props.userInfo || props.userInfo?.authenticatedUserMemberId !== "0") && (
                        <Hinweis
                          title="Gewerbeausübung"
                          link={MitgliedschaftPathEnum.RUHEND_WIEDERBETRIEB_MELDUNG}
                          userInfo={props.userInfo}
                          message="Ganz ohne Behördenwege – Mitgliedschaften bequem ruhend melden oder wiederaufnehmen!"
                        />
                      )}
                      {(!props.userInfo || props.userInfo?.personenbetreuer) && (
                        <Hinweis
                          title="Personenbetreuung"
                          link={MitgliedschaftPathEnum.PERSONENBETREUER}
                          userInfo={props.userInfo}
                          message="Ein Service nur für Mitglieder der Organisation für Personenbetreuung"
                        />
                      )}
                    </div>
                    <p>
                      Hier können Sie bequem und einfach Ihre Mitglieds- und Gewerbebestätigung zur Vorlage bei Ämtern
                      und Behörden anfordern und ausdrucken.{" "}
                    </p>
                    <p>
                      Die Dokumente werden zusätzlich unter <a href={getLink(URL_NACHRICHTEN)}>„Mein Postfach“</a> für
                      Sie bereitgestellt. Dort können Sie diese auch später erneut ausdrucken.{" "}
                    </p>
                  </>
                )}
              </>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
